import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { validateContactId } from "../../api/account";
import * as accountActions from "../../actions/accountActions";
import React, { PureComponent } from "react";
import Page from "../Page";
import LoadingButton from "../LoadingButton";


const strings = {
    error: "error",
    required: "This field is required",
    invalid: "The contact ID is invalid",
}

class ImpersonatePage extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,        
        storeImpersonatingContactId: PropTypes.func.isRequired,
        getMe: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            contactId: "",
            loading: false,
            invalid: false,
            isLoading: false,
            validation: {},
        };
    }

    componentDidMount = () => {

    }


    _submit = e => {
        if (e) {
            e.preventDefault();
        }

        let { validation } = this.state;

        if (!this.state.contactId) {
            validation["contactId"] = {
                state: strings.error,
                helpBlock: strings.required,
            }
        }

        this.setState({
            isLoading: true,
        })

        validateContactId(this.state.contactId)
            .then(response => {
                this.setState({
                    isLoading: false,
                });            

                if (response) {
                    this.props.storeImpersonatingContactId(this.state.contactId);                    
                    this.props.getMe().then(resp => {                        
                        this.props.history.push("/");    
                    });
                } else {
                    this.setState({
                        invalid: true,
                    });
                }
                
            })
            .catch(err => {
                this.setState({
                    invalid: true,
                    isLoading: false,
                });
            });

    }

    _handleChange = e => {
        let value = e.target.value;
        const numericOnly = /^[0-9\b]+$/;
        if (value === "" || numericOnly.test(value)) {
            this.setState({
                contactId: value,
            });
        }
    }

    _validForm = () => {

    }

    _renderError = () => {
        if (this.state.invalid) {
            return (
                <div className="row mt-3">
                    <div className="col-lg-6 col-10 text-bold text-center red-text col-centered">{strings.invalid}</div>                    
                </div>
            );
        }
    }

    render() {
        if (this.state.loading) {
            return <div className="loader" />
        }    

        return (
            <Page showHeader={false} title="">
                <div className="row mt-3">
                    <div className="col-lg-6 col-10 col-centered">
                        <label className="text-bold mb-3">Impersonated Contact ID</label>
                        <input type="text" 
                            name="contactId"                             
                            value={this.state.contactId} 
                            className="mb-4 mt-2"
                            maxLength={12}
                            onChange={this._handleChange} />                            
                        <LoadingButton text="Login" loadingText="Verifying contact..." isLoading={this.state.isLoading} onClick={this._submit} />
                    </div>
                </div>                
                {this._renderError()}
            </Page>
        );
    }
}

export default withRouter(connect(null, accountActions)(ImpersonatePage));